module.exports = __webpack_public_path__ + "fonts/SamsungSharpSans-Bold.93cd7ef4.woff2";